import React from 'react';
import { Flex, Button } from 'antd';
import { Title, Text } from 'components/Base/Typography';
import { AIIcon } from 'assets/icon/icon';
import { SCard } from './ChatBotCard.styles';

interface ChatBotCardProps {
  onOpenChat: () => void;
}

const ChatBotCard: React.FC<ChatBotCardProps> = ({ onOpenChat }) => {
  return (
    <SCard>
      <Flex vertical className="w-100 h-100" justify="center">
        <Flex vertical>
          <Title level={2} style={{ marginBottom: 24 }}>
            Ask AI
          </Title>

          <Flex align="center" justify="space-between">
            <Flex vertical style={{ flex: 1 }}>
              <Title level={4} style={{ marginBottom: 8 }}>
                Ask AI About Data You Don&apos;t See on the Dashboard
              </Title>
              <Text>
                Get instant answers to your questions about your data. Ask about
                trends, specific metrics, or any insights not visible on the
                dashboard.
              </Text>
            </Flex>

            <Flex align="center" justify="center" style={{ flex: 1 }}>
              <AIIcon size={129} />
            </Flex>
          </Flex>
        </Flex>

        <Flex justify="flex-start" style={{ marginTop: 24 }}>
          <Button type="primary" size="large" onClick={onOpenChat}>
            Ask AI
          </Button>
        </Flex>
      </Flex>
    </SCard>
  );
};

export default ChatBotCard;
